module.exports = __webpack_public_path__ + "img/chinesecompany209.9ff1e620.png";